import { $nodesOfType, TextNode } from "lexical"
import {
  getMatchingEndStart,
  getMatchingStart,
  removeFirstNChars,
  replaceLastNChars,
} from "./replaceHelpers"

export const onReplaceAll = ({ from, to, lastStateRef }, editor) => {
  let bufferText = ""
  let bufferNodesData = []
  editor.update(() => {
    const textNodes = $nodesOfType(TextNode)
    for (const node of textNodes) {
      const text = node.getTextContent()
      node.setTextContent(text.replaceAll(new RegExp(from, "gi"), to))
      const newText = node.getTextContent()
      if (bufferText.toLowerCase() === from.toLowerCase()) {
        if (bufferNodesData.length >= 2) {
          bufferNodesData.map((item, i) => {
            if (i === 0) {
              const text = item.node.getTextContent()
              const newText = replaceLastNChars(text, item.matchText.length, to)
              item.node.setTextContent(newText)
            }
            if (i > 0 && i < bufferNodesData.length - 1) {
              item.node.remove()
            }
            if (i === bufferNodesData.length - 1) {
              const text = item.node.getTextContent()
              const newText = removeFirstNChars(text, item.matchText.length)
              item.node.setTextContent(newText)
            }
            return undefined
          })
        }
        bufferText = ""
        bufferNodesData = []
      }
      if (bufferText) {
        const isMatchingFirst = getMatchingStart(
          newText,
          from.replace(new RegExp(bufferText, "i"), ""),
        )

        if (isMatchingFirst.length) {
          bufferText = bufferText + isMatchingFirst
          bufferNodesData.push({ node: node, matchText: isMatchingFirst })
        }
        if (bufferText.toLowerCase() === from.toLowerCase()) {
          if (bufferNodesData.length >= 2) {
            bufferNodesData.map((item, i) => {
              if (i === 0) {
                const text = item.node.getTextContent()
                const newText = replaceLastNChars(text, item.matchText.length, to)
                item.node.setTextContent(newText)
              }
              if (i > 0 && i < bufferNodesData.length - 1) {
                item.node.remove()
              }
              if (i === bufferNodesData.length - 1) {
                const text = item.node.getTextContent()
                const newText = removeFirstNChars(text, item.matchText.length)
                item.node.setTextContent(newText)
              }
              return undefined
            })
          }
          bufferText = ""
          bufferNodesData = []
        }
      }

      const isMatching = getMatchingEndStart(newText, from)
      if (isMatching.length) {
        bufferText = isMatching
        bufferNodesData = []
        bufferNodesData.push({ node: node, matchText: isMatching })
      }
    }
  })

  setTimeout(() => {
    lastStateRef.current = editor.getEditorState()
  }, 0)

  return true
}
